import React, { useEffect, useState } from 'react';

import { HintText, HintListContainer } from './styled';
import { useHintContainer } from '../../context/useHintContainerContext';
import HintTimer from './helpers/HintTimer';
import HintPopover from './helpers/Popover/index';

const HintContainer = ({ game, round }) => {
  const { queue, visible, checkWarning, showWarning } = useHintContainer();

  const allRounds = game?.playerGame?.rounds;
  const [hintActive, activeHintHandler] = useState(false);
  const [testHandler, setTestHandler] = useState(false);
  const [toggleRenderWarning, setToggleRenderWarning] = useState(false);
  const [renderFinalHint, setRenderFinalHint] = useState(false);

  useEffect(() => {
    if (queue.length > 0) {
      setTestHandler(true);
      let el = document.getElementById('scrollContainerHints');
      el.scrollTop = el.scrollHeight;
    } else {
      setTestHandler(false);
      let el = document.getElementById('scrollContainerHints');
      el.scrollTop = el.scrollHeight;
    }
  }, [queue, visible]);

  const handleHintActivation = () => {
    activeHintHandler(true);
  };

  const testingMakingHintActive = () => {
    checkWarning();
  };

  return (
    <div>
      <HintTimer
        allRounds={allRounds}
        round={round}
        handleHintActivation={handleHintActivation}
      />
      <HintPopover
        showHint={testingMakingHintActive}
        active={testHandler}
        toggleRenderWarning={showWarning}
        setRenderFinalHint={setRenderFinalHint}
        renderFinalHint={renderFinalHint}
        setToggleRenderWarning={setToggleRenderWarning}
      ></HintPopover>
      <HintListContainer className='scrollContainer' id='scrollContainerHints'>
        {visible?.map((hint) => {
          return <HintText key={hint.id}>{hint.body}</HintText>;
        })}
      </HintListContainer>
    </div>
  );
};

export default HintContainer;
